import React, { useEffect, useState } from "react";
import Head from "next/head";
import AllCategories from "../../components/OnlineTrainingSchool/AllCategories";
import TopCategories from "../../components/OnlineTrainingSchool/TopCategories";
import Footer from "../../components/_App/Footer";
import Navbar from "../../components/_App/Navbar1";
import PageBanner from "../../components/Common/PageBanner";

import { WEB_API } from "../../constants";

export default function Categories({ dataNav, categories }) {
  const [tabUrl, setTabUrl] = useState(null);
  const [title, setTitle] = useState("");
  const [images, setImages] = useState(null);
  useEffect(() => {
    setTabUrl(window.location.href);
    setTitle(document.title);
    setImages(document.images[0].src);
  }, []);

  return (
    <React.Fragment>
      <Navbar data={dataNav} />
      <PageBanner
        pageTitle="Categories"
        homePageUrl="/"
        homePageText="Home"
        activePageText="Categories"
      />
      <div>
        <Head>
          <link
            href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css"
            rel="stylesheet"
            integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
            crossorigin="anonymous"
          ></link>
          <meta
            name="viewport"
            content="initial-scale=1.0, width=device-width"
          />
          <meta property="og:title" content={title} />
          <meta
            name="description"
            content="Save your most valuable Time, and Money with expert-curated content and personalized learning."
          />
          <meta
            property="og:description"
            content="Save your most valuable Time, and Money with expert-curated content and personalized learning."
          />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={tabUrl} />
          <meta property="og:image" content={images} />
          <link
            rel="canonical"
            // property="og:title"
            // content={title}
            // key="title"
            href={tabUrl}
          ></link>
        </Head>
      </div>

      {categories && <AllCategories data={categories} />}

      <Footer />
    </React.Fragment>
  );
}

export const getStaticProps = async (context) => {
  const res = await fetch(WEB_API + "/categories/list");
  const categories = await res.json();

  return {
    props: { categories },
  };
};
